var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09467 10.966L0.219661 6.09099C-0.0732203 5.79811 -0.0732203 5.32324 0.219661 5.03033L1.2803 3.96966C1.57318 3.67675 2.04808 3.67675 2.34096 3.96966L5.625 7.25367L12.659 0.219661C12.9519 -0.0732203 13.4268 -0.0732203 13.7197 0.219661L14.7803 1.28033C15.0732 1.57321 15.0732 2.04808 14.7803 2.34099L6.15533 10.966C5.86242 11.2589 5.38755 11.2589 5.09467 10.966Z",
    fill: "#25D366"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNice);
export default __webpack_public_path__ + "static/media/nice.2c31b2ad7e4206f80230d6fd1380dcb5.svg";
export { ForwardRef as ReactComponent };